import React, { useState, useEffect, useRef } from 'react';
import { BrowserRouter, Route, Switch, Redirect, useHistory } from 'react-router-dom';
import Login from '../areas/controleAcesso/usuario/pages/Login';
import RecuperacaoSenha from '../areas/controleAcesso/usuario/pages/RecuperacaoSenha';
import NovaSenha from '../areas/controleAcesso/usuario/pages/NovaSenha';
import { getAutenticado, logout, getUsuario } from './Configuracoes'
import { ACOES } from './Enums'
import { get } from './AcessoApi'
import NaoEncontrado from '../areas/controleAcesso/util/pages/NaoEncontrado'
import Dashboard from '../areas/shared/Dashboard'
import Home from '../areas/shared/Home'

// Controle de Acesso
import CadastroUsuario from '../areas/controleAcesso/usuario/pages/Cadastro'
import ConsultaUsuario from '../areas/controleAcesso/usuario/pages/Consulta'
import AlteracaoSenha from '../areas/controleAcesso/usuario/pages/AlteracaoSenha'
import CadastroExterno from '../areas/controleAcesso/usuario/pages/CadastroExterno'
import VisualizacaoUsuario from '../areas/controleAcesso/usuario/pages/Visualizacao'

import ConsultaGrupo from '../areas/controleAcesso/grupo/pages/Consulta'
import CadastroGrupo from '../areas/controleAcesso/grupo/pages/Cadastro'
import VisualizacaoGrupo from '../areas/controleAcesso/grupo/pages/Visualizacao'

import ConsultaAuditoria from '../areas/controleAcesso/auditoria/pages/Consulta'

// Faturamento
import ConsultaBeneficiario from '../areas/atendimento/beneficiario/pages/Consulta'
import CadastroBeneficiario from '../areas/atendimento/beneficiario/pages/Cadastro'
import VisualizacaoBeneficiario from '../areas/atendimento/beneficiario/pages/Visualizacao'

import ConsultaCooperadoPf from '../areas/faturamento/cooperado-pf/pages/Consulta'
import CadastroCooperadoPf from '../areas/faturamento/cooperado-pf/pages/Cadastro'
import VisualizacaoCooperadoPf from '../areas/faturamento/cooperado-pf/pages/Visualizacao'

import ConsultaCooperadoPj from '../areas/faturamento/cooperado-pj/pages/Consulta'
import CadastroCooperadoPj from '../areas/faturamento/cooperado-pj/pages/Cadastro'
import VisualizacaoCooperadoPj from '../areas/faturamento/cooperado-pj/pages/Visualizacao'

// Atendimento
import ConsultaProntuario from '../areas/atendimento/prontuario/pages/Consulta'
import CadastroProntuario from '../areas/atendimento/prontuario/pages/Cadastro'
import VisualizacaoProntuario from '../areas/atendimento/prontuario/pages/Visualizacao'

import ConsultaPrestador from '../areas/atendimento/prestador/pages/Consulta'
import CadastroPrestador from '../areas/atendimento/prestador/pages/Cadastro'
import VisualizacaoPrestador from '../areas/atendimento/prestador/pages/Visualizacao'

import ConsultaPrestadorCbos from '../areas/atendimento/prestador_cbos/pages/Consulta'
import CadastroPrestadorCbos from '../areas/atendimento/prestador_cbos/pages/Cadastro'
import VisualizacaoPrestadorCbos from '../areas/atendimento/prestador_cbos/pages/Visualizacao'

import ConsultaPrestadorConselhoProf from '../areas/atendimento/prestador_conselho_profissional/pages/Consulta'
import CadastroPrestadorConselhoProf from '../areas/atendimento/prestador_conselho_profissional/pages/Cadastro'
import VisualizacaoPrestadorConselhoProf from '../areas/atendimento/prestador_conselho_profissional/pages/Visualizacao'

import ConsultaAgenda from '../areas/atendimento/agenda/pages/Consulta'
import CadastroAgenda from '../areas/atendimento/agenda/pages/Cadastro'
import VisualizacaoAgenda from '../areas/atendimento/agenda/pages/Visualizacao'

import ConsultaSalaEspera from '../areas/atendimento/sala-espera/pages/Consulta'

import SemPermissao from '../areas/shared/SemPermissao'
import SemAcesso from '../areas/shared/SemAcesso'
import moment from "moment"
import ListagemAlternativa from '../areas/shared/ListagemAlternativa'
import ls from 'local-storage'


import Layout from './Layout'
import Painel from '../areas/atendimento/painel/pages/Painel';

const PrivateRoute = (propsG) => {
    const { component: Component, fazerAuditoria, configState, ...rest } = propsG
    const [temPermissao, setTemPermissao] = useState(false)
    const [validou, setValidou] = useState(false)
    const [menuAberto, setMenuAberto] = useState(true)

    const user = getUsuario()

    const removerDataConsultaAgenda = (propsG) => {
        if (propsG.modulo != 38) {
            // ls.remove('ultima_data_consulta_agenda')
        }
    }

    const history = useHistory();
    useEffect(() => {


        if (user) {
            removerDataConsultaAgenda(propsG);
            //permitido
            const objPermissao = {
                usuario_id: (user && user.id) || 0,
                modulo_id: propsG.modulo,
                acao_id: propsG.acao
            }

            if (propsG.modulo === undefined || propsG.modulo === 4) {
                setValidou(true)
                setTemPermissao(true)
            }
            else {
                get('/controleAcesso/permissao', objPermissao).then(val => {
                    if (val.length)
                        setTemPermissao(true);
                    else
                        setTemPermissao(false);

                    setValidou(true)
                }).catch(e => {
                    setTemPermissao(false);
                    setValidou(true)
                })
            }

            if (!propsG.path.includes('logout') || !propsG.path.includes('login'))
                ls.set('ultimo_hora_login', moment())

        }
    }, [propsG, propsG.path, user])

    // let redirecinarParaHome = propsG.path.includes('dashboard') && ls.get('permissaoDashboard') === false;
    // let redirecinarParaHome = propsG.path.includes('dashboard') && ls.get('permissaoDashboard') === false;
    // if (redirecinarParaHome) {
    //     setTimeout(() => {
    //         window.location.reload();
    //     }, 1000);
    //     return (<Redirect to={{ pathname: '/home', state: { from: propsG.location, ...configState } }} />)
    // }

    if (!user)
        return (<Redirect to={{ pathname: '/login', state: { from: propsG.location, ...configState } }} />)
    if (validou == true)
        return (<Layout setMenuAberto={setMenuAberto} temPermissao={propsG.modulo == 4 ? true : temPermissao}><Route {...rest} render={props =>
            getAutenticado() ? (<Component menuAberto={menuAberto}  {...props} configState={configState} modulo={propsG.modulo} icone={propsG.icone} />) : (<Redirect to={{ pathname: '/login', state: { from: props.location } }} />)
        } /></Layout>)
    else
        return <></>
}
const reload = () => {
    if (window.localStorage) {
        if (!localStorage.getItem('firstLoad')) {
            localStorage['firstLoad'] = true;
            window.location.reload();
        }
        else
            localStorage.removeItem('firstLoad');
    }
}

const LoginRoute = ({ component: Component, realizarLogout, ...rest }) => {

    if (realizarLogout) {
        logout()
        reload()
    }

    return (<Route {...rest} render={props =>
        getAutenticado() ? (<Redirect to={{ pathname: ls.get('permissaoDashboard') === false ? '/home' : '/dashboard', state: { from: props.location } }} />) : (<Component {...props} />)
    } />)
}

const Routes = (rProps) => (
    <BrowserRouter>
        <Switch>
            {/* CONTROLE ACESSO */}
            <PrivateRoute modulo={2} acao={ACOES.INSERIR} path='/controleAcesso/grupo/cadastro' active='/controleAcesso/grupo/consulta' component={(props) => <CadastroGrupo {...props} />} />
            <PrivateRoute modulo={2} acao={ACOES.ALTERAR} path='/controleAcesso/grupo/alteracao/:id' active='/controleAcesso/grupo/consulta' component={(props) => <CadastroGrupo {...props} idSubmenu="" />} />
            <PrivateRoute modulo={2} acao={ACOES.CONSULTAR} path='/controleAcesso/grupo/consulta' component={(props) => <ConsultaGrupo {...props} />} />
            <PrivateRoute modulo={2} acao={ACOES.VISUALIZAR} path='/controleAcesso/grupo/visualizacao/:id' active='/controleAcesso/grupo/consulta' component={(props) => <VisualizacaoGrupo {...props} />} />

            <PrivateRoute modulo={1} acao={ACOES.INSERIR} path='/controleAcesso/usuario/cadastro' active='/controleAcesso/usuario/consulta' component={(props) => <CadastroUsuario {...props} />} />
            <PrivateRoute modulo={1} acao={ACOES.ALTERAR} path='/controleAcesso/usuario/alteracao/:id' active='/controleAcesso/usuario/consulta' component={(props) => <CadastroUsuario {...props} />} />
            <PrivateRoute modulo={1} acao={ACOES.ALTERAR} path='/controleAcesso/usuario/alteracaoSenha' component={(props) => <AlteracaoSenha {...props} />} />
            <PrivateRoute modulo={1} acao={ACOES.CONSULTAR} path='/controleAcesso/usuario/consulta' component={(props) => <ConsultaUsuario {...props} />} />
            <PrivateRoute modulo={1} acao={ACOES.VISUALIZAR} path='/controleAcesso/usuario/visualizacao/:id' active='/controleAcesso/usuario/consulta' component={(props) => <VisualizacaoUsuario {...props} />} />
            <Route path='/controleAcesso/usuarioExterno/cadastro/:id' component={(props) => <CadastroExterno {...props} />} />
            <PrivateRoute modulo={5} acao={ACOES.CONSULTAR} path='/controleAcesso/auditoria/consulta' component={(props) => <ConsultaAuditoria {...props} />} />

            {/* FATURAMENTO */}
            <PrivateRoute modulo={6} acao={ACOES.INSERIR} path='/atendimento/beneficiario/cadastro' component={(props) => <CadastroBeneficiario {...props} />} />
            <PrivateRoute modulo={6} acao={ACOES.ALTERAR} path='/atendimento/beneficiario/alteracao/:id' active='/atendimento/beneficiario/consulta' component={(props) => <CadastroBeneficiario {...props} />} />
            <PrivateRoute modulo={6} icone={'icon-Mens'} acao={ACOES.CONSULTAR} path='/atendimento/beneficiario/consulta' component={(props) => <ConsultaBeneficiario {...props} />} />
            <PrivateRoute modulo={6} acao={ACOES.VISUALIZAR} path='/atendimento/beneficiario/visualizacao/:id' active='/atendimento/beneficiario/consulta' component={(props) => <VisualizacaoBeneficiario {...props} />} />

            <PrivateRoute modulo={7} acao={ACOES.INSERIR} path='/faturamento/cooperadopf/cadastro' component={(props) => <CadastroCooperadoPf {...props} />} />
            <PrivateRoute modulo={7} acao={ACOES.ALTERAR} path='/faturamento/cooperadopf/alteracao/:id' active='/faturamento/cooperadopf/consulta' component={(props) => <CadastroCooperadoPf {...props} />} />
            <PrivateRoute modulo={7} icone={'icon-Doctor'} acao={ACOES.CONSULTAR} path='/faturamento/cooperadopf/consulta' component={(props) => <ConsultaCooperadoPf {...props} />} />
            <PrivateRoute modulo={7} acao={ACOES.VISUALIZAR} path='/faturamento/cooperadopf/visualizacao/:id' active='/faturamento/cooperadopf/consulta' component={(props) => <VisualizacaoCooperadoPf {...props} />} />

            <PrivateRoute modulo={8} acao={ACOES.INSERIR} path='/faturamento/cooperadopj/cadastro' component={(props) => <CadastroCooperadoPj {...props} />} />
            <PrivateRoute modulo={8} acao={ACOES.ALTERAR} path='/faturamento/cooperadopj/alteracao/:id' active='/faturamento/cooperadopj/consulta' component={(props) => <CadastroCooperadoPj {...props} />} />
            <PrivateRoute modulo={8} icone={'icon-Business-ManWoman'} acao={ACOES.CONSULTAR} path='/faturamento/cooperadopj/consulta' component={(props) => <ConsultaCooperadoPj {...props} />} />
            <PrivateRoute modulo={8} acao={ACOES.VISUALIZAR} path='/faturamento/cooperadopj/visualizacao/:id' active='/faturamento/cooperadopj/consulta' component={(props) => <VisualizacaoCooperadoPj {...props} />} />

            <PrivateRoute modulo={9} acao={ACOES.INSERIR} path='/atendimento/prontuario/cadastro' component={(props) => <CadastroProntuario {...props} />} />
            <PrivateRoute modulo={9} acao={ACOES.ALTERAR} path='/atendimento/prontuario/alteracao/:id' active='/atendimento/prontuario/consulta' component={(props) => <CadastroProntuario {...props} />} />
            <PrivateRoute modulo={9} icone={'icon-File-ClipboardFileText'} acao={ACOES.CONSULTAR} path='/atendimento/prontuario/consulta' component={(props) => <ConsultaProntuario {...props} />} />
            <PrivateRoute modulo={9} acao={ACOES.VISUALIZAR} path='/atendimento/prontuario/visualizacao/:id' active='/atendimento/prontuario/consulta' component={(props) => <VisualizacaoProntuario {...props} />} />

            <PrivateRoute modulo={11} acao={ACOES.INSERIR} path='/atendimento/prestador/cadastro' component={(props) => <CadastroPrestador {...props} />} />
            <PrivateRoute modulo={11} acao={ACOES.ALTERAR} path='/atendimento/prestador/alteracao/:id' active='/atendimento/prestador/consulta' component={(props) => <CadastroPrestador {...props} />} />
            <PrivateRoute modulo={11} icone={'icon-File-ClipboardFileText'} acao={ACOES.CONSULTAR} path='/atendimento/prestador/consulta' component={(props) => <ConsultaPrestador {...props} />} />
            <PrivateRoute modulo={11} acao={ACOES.VISUALIZAR} path='/atendimento/prestador/visualizacao/:id' active='/atendimento/prestador/consulta' component={(props) => <VisualizacaoPrestador {...props} />} />

            <PrivateRoute modulo={12} acao={ACOES.INSERIR} path='/atendimento/prestadorcbos/cadastro' component={(props) => <CadastroPrestadorCbos {...props} />} />
            <PrivateRoute modulo={12} acao={ACOES.ALTERAR} path='/atendimento/prestadorcbos/alteracao/:id' active='/atendimento/prestadorcbos/consulta' component={(props) => <CadastroPrestadorCbos {...props} />} />
            <PrivateRoute modulo={12} icone={'icon-File-ClipboardFileText'} acao={ACOES.CONSULTAR} path='/atendimento/prestadorcbos/consulta' component={(props) => <ConsultaPrestadorCbos {...props} />} />
            <PrivateRoute modulo={12} acao={ACOES.VISUALIZAR} path='/atendimento/prestadorcbos/visualizacao/:id' active='/atendimento/prestadorcbos/consulta' component={(props) => <VisualizacaoPrestadorCbos {...props} />} />

            <PrivateRoute modulo={13} acao={ACOES.INSERIR} path='/atendimento/prestadorconselhoprof/cadastro' component={(props) => <CadastroPrestadorConselhoProf {...props} />} />
            <PrivateRoute modulo={13} acao={ACOES.ALTERAR} path='/atendimento/prestadorconselhoprof/alteracao/:id' active='/atendimento/prestadorconselhoprof/consulta' component={(props) => <CadastroPrestadorConselhoProf {...props} />} />
            <PrivateRoute modulo={13} icone={'icon-File-ClipboardFileText'} acao={ACOES.CONSULTAR} path='/atendimento/prestadorconselhoprof/consulta' component={(props) => <ConsultaPrestadorConselhoProf {...props} />} />
            <PrivateRoute modulo={13} acao={ACOES.VISUALIZAR} path='/atendimento/prestadorconselhoprof/visualizacao/:id' active='/atendimento/prestadorconselhoprof/consulta' component={(props) => <VisualizacaoPrestadorConselhoProf {...props} />} />

            {/* <PrivateRoute modulo={9} acao={ACOES.INSERIR} path='/atendimento/prontuario/cadastro' component={(props) => <CadastroProntuario {...props} />} />
            <PrivateRoute modulo={9} acao={ACOES.ALTERAR} path='/atendimento/prontuario/alteracao/:id' active='/atendimento/prontuario/consulta' component={(props) => <CadastroProntuario {...props} />} /> */}
            <PrivateRoute modulo={10} icone={'icon-File-ClipboardFileText'} acao={ACOES.CONSULTAR} path='/atendimento/agenda/consulta' component={(props) => <ConsultaAgenda {...props} />} />
            <PrivateRoute modulo={10} acao={ACOES.VISUALIZAR} path='/atendimento/prontuario/visualizacao/:id' active='/atendimento/agenda/consulta' component={(props) => <VisualizacaoAgenda {...props} />} />

            <PrivateRoute modulo={10} acao={ACOES.CONSULTAR} path='/atendimento/sala-espera/consulta' active='/atendimento/sala-espera/consulta' component={(props) => <ConsultaSalaEspera {...props} />} />

            <PrivateRoute modulo={4} path='/semPermissao' component={(props) => <SemPermissao {...props} />} />
            <PrivateRoute modulo={4} path='/semAcesso' component={(props) => <SemAcesso {...props} />} />
            <PrivateRoute modulo={4} path='/dashboard' component={() => <Dashboard {...rProps} />} />

            <LoginRoute path='/login' component={(props) => <Login {...props} />} />
            <LoginRoute exact path='/' component={() => <Login />} />
            <LoginRoute path='/logout' component={(props) => <Login {...props} />} realizarLogout={true} />
            <Route path='/recuperarSenha' component={(props) => <RecuperacaoSenha  {...props} />} />
            <Route path='/novasenha/:token' component={(props) => <NovaSenha  {...props} />} />
            <Route path='/atendimento/painel' component={(props) => <Painel {...props} />} />

            {/* GERAL */}
            {/* <PrivateRoute modulo={4} path='/listagem' component={(props) => <ListagemPadrao {...props} />} /> */}
            <PrivateRoute modulo={4} path='/listagemAlternativa' component={(props) => <ListagemAlternativa {...props} />} />
            <PrivateRoute path='/home' component={() => <Home />} />

            <Route path="*"><NaoEncontrado /></Route>
        </Switch >
    </BrowserRouter >
)

export default Routes;
export { reload }